module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Social_Rating":{"handleDom.rate.callback":[{"value":function (elt) {
if (fox.site.member) return this.rateDomHandler(elt);
if (!isNaN(parseInt(elt.getAttribute('data-target-id')))) return this.rateDomHandler(elt);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Social_Rating","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/socilaRating.js
// module id = 719
// module chunks = 4